import { render } from "./AccountAddView.vue?vue&type=template&id=b142083a&scoped=true"
import script from "./AccountAddView.vue?vue&type=script&lang=js"
export * from "./AccountAddView.vue?vue&type=script&lang=js"

import "./AccountAddView.vue?vue&type=style&index=0&id=b142083a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b142083a"

export default script